<template>
    <div>
        <modal :show.sync="show" :large="true">
            <div class="modal-header"
                 slot="modal-header">
                <h4>Sélectionner les contrats à conserver</h4>
            </div>

            <div class="modal-body"
                 slot="modal-body">
                <loader v-show="loading"></loader>
                <div v-if="!loading">
                <contract-box v-for="contract in contracts" track-by="$index"
                              :selected="isContractToKeep(contract)"
                              :on-click="selectContract"
                              :contract.sync="contract"></contract-box>
                </div>
            </div>

            <div slot="modal-footer" class="modal-footer cta">
                <button class="btn btn-default" :disabled="loading"
                   @click.prevent="show = false">
                    Annuler
                </button>
                <button class="btn btn-primary -select-contract"
                        :disabled="loading" @click.prevent="validate">
                    Valider
                </button>
            </div>
        </modal>
    </div>
</template>

<style lang="less" type="text/less" scoped>
    tr {
        .-select-client-btn {
            visibility: hidden;
            color: #fff !important;
            text-decoration: none;
        }
        &:hover {
            .-select-client-btn {
                visibility: visible;
            }
        }
    }
</style>

<script>
    import Loader from '../../components/Loader';
    import ContractBox from './ContractBox';
    import Modal from 'vue-strap/src/Modal';
    import {list as listContracts} from '../../api/contract';

    export default {
        components: {
            Loader,
            ContractBox,
            Modal
        },
        name: 'select-contracts-modal',
        props: {
            onValidate: Function
        },
        data() {
            return {
                show: false,
                contracts: [],
                contractsToKeep: [],
                loading: false,
                clients: []
            };
        },

        methods: {
            /**
             * Helper method, return true if the contact passed in parameter
             * is already in the list of contracts to keep
             */
            isContractToKeep(contract) {
                return this.contractsToKeep.filter(c => contract.id === c.id).length > 0;
            },
            /**
             * Load and merge contracts from the 2 clients
             */
            loadContracts: async function() {
                this.loading = true;
                const contracts1 = await listContracts(this.clients[0].id);
                const contracts2 = await listContracts(this.clients[1].id);
                this.contracts = contracts1.concat(contracts2);
                this.contractsToKeep = this.contracts;
                this.loading = false;
            },
            /**
             * Handle click on contract.
             * If contract is already selected, remove it from the contract
             * list to keep. Otherwise, add it to this list
             */
            selectContract(contract) {
                if (!this.isContractToKeep(contract)) {
                    this.contractsToKeep.push(contract);
                    return;
                }
                this.contractsToKeep = this.contractsToKeep.filter(c => c.id !== contract.id);
            },
            validate() {
                this.onValidate(this.clients, this.contractsToKeep);
                this.show = false;
            }
        },
        events: {
            /**
             * Open the select contract modal
             * @param clients array of clients to merge
             */
            'client-merge-contracts-select': function (clients) {
                this.clients = clients;
                this.loadContracts();
                this.show = true;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// SelectContractsModal.vue?2ce41110